<template>
    <b-modal
        id="checkoutModal"
        v-model="modalShow"
        size="lg"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body">
            <div class="modal-header">
                <span>Sunteți sigur că doriți să schimbați pagina?</span>
            </div>
            <p>Exista unul sau mai multe câmpuri completate. Aceste informații se vor pierde. Continuați?</p>

            <div class="example">
                <p>Înainte de a părăsi pagina, nu uita să salvezi formularul folosind acest câmp.</p>
                <b-form-checkbox
                    v-model="checked"
                    switch
                    size="lg"
                    class="switch-box"
                    disabled
                >Informațiile sunt complete și corecte</b-form-checkbox>
            </div>


            <div class="buttons-list flex">
                <div class="button-confirm" @click="$emit('changeRoute', true); $emit('achizitiiChanged'); modalShow = false;">Da</div>
                <div class="button-confirm" @click="$emit('changeRoute', false)">Nu</div>
            </div>

        </div>
    </b-modal>
</template>

<script>
    import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconTrash, BFormTextarea, BFormFile, BIconUpload, BFormCheckbox} from 'bootstrap-vue';
    export default {
        name: "ChangeRoutePopup",

        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            BFormCheckbox
        },
        props: {
            schimbaModal: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                checked: false,
                modalShow: false
            }
        },
        watch: {
            schimbaModal: {
                handler: function() {
                    this.modalShow = this.schimbaModal
                },
                deep: true
            }
        },
        methods: {
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                    this.$emit('changeRoute', false)
                }
            },
        },
    }
</script>

<style scoped>

.modal-body{
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.modal-body >>> .modal-header span {
  font-size: 19px;
  font-weight: 700;
  color: #fff;
}
.modal-body >>> .modal-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  position: relative;
}
.modal-body p{
  color: #fff;
  text-align: center;
  margin-top: 15px;
}
.custom-switch >>> .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(0.8rem) !important;
}
.custom-switch >>> .custom-control-label::after {
    top: calc( 0.3125rem + 3px );
    left: calc( -2.8125rem + 4px );
    width: calc( 1.25rem - 5px );
    height: calc( 1.25rem - 5px );
    border-radius: 0.6rem;
    background-size: 41% 18%;
}
.buttons-list{
    width: 100%;
    max-width: 350px;
    justify-content: space-between;
    margin-top: 15px;
}
.button-confirm{
  color: #fff;
  font-size: 14px;
  border: 1px solid #fff;
  border-radius: 4px;
  text-align: center;
  padding: 5px 10px;
  width: 40%;
  margin-bottom: 5px;
}
.button-confirm:hover{
  background: #fff;
  color: #000;
  cursor: pointer;
}
.example{
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 0;
}
.example p{
    margin-bottom: 5px;
}
.switch-box{
    text-align: right;
}
.custom-switch >>> .custom-control-label::after{
    background-color: #8c6984;
}
.custom-switch >>> .custom-control-label::before{
    border-color: #8c6984;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #fff !important;
    line-height: 2 !important;
}
.switch-box:disabled >>> label{
    color: #fff;
}
</style>